import { Box, Button, Card, Container, CssBaseline, Grid, ThemeProvider, Typography, useMediaQuery } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import QRCode from 'qrcode.react';
import Logo from 'src/components/LogoSign';
import CurrentLottery from 'src/content/dashboards/Lottery/CurrentLottery';
import { useCallback, useEffect, useState } from 'react';
import { Lottery } from 'src/util/types';
import axios from 'axios';
import config from '../../../config';
import announcementImg from './gs3.png';
import Marquee from 'react-fast-marquee';
import { useAuth } from "../../../util/authenticationProvider";

export default function QRCodeDisplayPage() {
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#000000',
        paper: '#000000'
      },
      text: {
        primary: '#ffffff',
        secondary: '#cccccc'
      }
    },
    colors: {
      gradients: {
        blue1: '',
        blue2: '',
        blue3: '',
        blue4: '',
        blue5: '',
        orange1: '',
        orange2: '',
        orange3: '',
        purple1: '',
        purple3: '',
        pink1: '',
        pink2: '',
        green1: '',
        green2: '',
        black1: '',
        black2: ''
      },
      shadows: {
        success: '',
        error: '',
        primary: '',
        warning: '',
        info: ''
      },
      alpha: {
        white: {
          5: '',
          10: '',
          30: '',
          50: '',
          70: '',
          100: ''
        },
        trueWhite: {
          5: '',
          10: '',
          30: '',
          50: '',
          70: '',
          100: ''
        },
        black: {
          5: '',
          10: '',
          30: '',
          50: '',
          70: '',
          100: ''
        }
      },
      secondary: {
        lighter: '',
        light: '',
        main: '',
        dark: ''
      },
      primary: {
        lighter: '',
        light: '',
        main: '',
        dark: ''
      },
      success: {
        lighter: '',
        light: '',
        main: '',
        dark: ''
      },
      warning: {
        lighter: '',
        light: '',
        main: '',
        dark: ''
      },
      error: {
        lighter: '',
        light: '',
        main: '',
        dark: ''
      },
      info: {
        lighter: '',
        light: '',
        main: '',
        dark: ''
      }
    },
    general: {
      reactFrameworkColor: undefined,
      borderRadiusSm: '',
      borderRadius: '',
      borderRadiusLg: '',
      borderRadiusXl: ''
    },
    sidebar: {
      background: undefined,
      boxShadow: undefined,
      width: '',
      textColor: undefined,
      dividerBg: undefined,
      menuItemColor: undefined,
      menuItemColorActive: undefined,
      menuItemBg: undefined,
      menuItemBgActive: undefined,
      menuItemIconColor: undefined,
      menuItemIconColorActive: undefined,
      menuItemHeadingColor: undefined
    },
    header: {
      height: '',
      background: undefined,
      boxShadow: undefined,
      textColor: undefined
    }
  });
  const isMobile = useMediaQuery(darkTheme.breakpoints.down('sm'));
  const { tokens } = useAuth();
  const [lottery, setLottery] = useState<Lottery>();
  const [qrCodeVal, setQrCodeVal] = useState<string>('');
  const [marqueeImages, setMarqueeImages] = useState<any[]>([]);

  const accessToken = tokens?.accessToken ?? '';

  const fetchGalleryImages = useCallback(async () => {
    try {
      const res = await axios.get(config.apiUrl + '/api/media/all', {
        headers: accessToken ? {
          'Authorization': `Bearer ${accessToken}`
        } : undefined
      });

      if (res.data.status >= 200 && Array.isArray(res.data.content)) {
        const galleryImages = res.data.content
          .filter((media: any) => media.category === 'gallery')
          .map((media: any) => ({
            src: media.image,
            title: media.title,
            id: media.id
          }));
        setMarqueeImages(galleryImages);
      } else {
        setMarqueeImages([]);
      }
    } catch {
      setMarqueeImages([]);
    }
  }, [accessToken]);

  const fetchQRCodeValue = useCallback(async () => {
    try {
      const res = await axios.get(config.apiUrl + '/api/lottery/current', {
        headers: accessToken ? {
          'Authorization': `Bearer ${accessToken}`
        } : undefined
      });
      if (res.data.status >= 200) {
        setLottery(res.data.content);
      }
    } catch (err) {
      console.log("Couldn't fetch current Game", err);
    }
  }, [accessToken]);

  useEffect(() => {
    fetchGalleryImages();
  }, [accessToken, fetchGalleryImages]);

  useEffect(() => {
    fetchQRCodeValue();
    const interval = setInterval(fetchQRCodeValue, 5000);
    return () => clearInterval(interval);
  }, [accessToken, fetchQRCodeValue]);

  useEffect(() => {
    if (lottery) {
      const path = `${window.location.origin}/join/${lottery.id}`;
      setQrCodeVal(path);
    } else {
      setQrCodeVal('');
    }
  }, [lottery]);

  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary', minHeight: '100vh' }}>
        <Container component="main" maxWidth="lg" sx={{ marginTop: '30px' }}>
          <Card>
            <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={1}>
              <Grid item md={4} xs={12}>
                {lottery ? (
                  <Box
                    sx={{
                      marginTop: 1,
                      marginBottom: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                      textAlign: 'center',
                      backgroundRepeat: 'no-repeat'
                    }}
                  >
                    <Logo />
                    <img src={announcementImg} width="100%" alt="Announcement" />
                    <h2>Sei dabei und sichere dir tolle Preise!</h2>
                    
                    <Box
                      sx={{
                        marginTop: 3,
                        marginBottom: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      {isMobile ? (
                        <Button
                          variant="contained"                          
                          href={qrCodeVal}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ px: 4, py: 2, borderRadius: 2, fontSize: '1.5rem' ,backgroundColor:"#dca735"}}
                          disabled={!qrCodeVal}
                        >
                          Jetzt Teilnehmen
                        </Button>
                      ) : (
                        
                        <Card sx={{ backgroundColor: '#fff', padding: '20px', borderRadius: '10px' }}>
                          <QRCode value={qrCodeVal} size={256} />
                        </Card>
                      )}
                     </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      marginTop: 8,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      maxHeight: '600px'
                    }}
                  >
                    <Logo />
                    <Typography component="h1" variant="h4" sx={{ margin: '15px' }} color="text.secondary">
Gewinnspiel startet in Kürze                   
</Typography>
                  </Box>
                )}
              </Grid>
              <Grid item md={8} xs={12}>
                <Grid item md={12} xs={12}>
                  {lottery ? (
                    <CurrentLottery lotteryData={lottery} />
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        padding: '30px'
                      }}
                    >
                      <h1>Bewerten Sie Uns</h1>
                      <Box
                      sx={{
                        marginTop: 3,
                        marginBottom: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      backgroundColor:'#fff',
                      width:'160px',
                      borderRadius:'10px',
                      padding:'15px',
                      }}
                    >
                      <QRCode value='https://go.ennorev.de/maki' />
                      </Box>
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Grid container item md={12} xs={12} direction='row'>
                <Marquee direction='right'>
                  {marqueeImages.map((img, idx) => (
                    <Box key={img.id || idx} sx={{ paddingRight: '20px', textAlign: 'center' }}>
                      <img
                        src={img.src}
                        width='180'
                        alt={img.title || `marquee-${idx}`}
                        style={{ objectFit: 'contain', maxHeight: 180, background: '#fff' }}
                        onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
                      />
                    </Box>
                  ))}
                </Marquee>
              </Grid>
            </Grid>
          </Card>
        </Container>
        </Box>
      </ThemeProvider>
    </>
  );
}
